export enum DistanceUnitEnum {
  Meters = "meters",
  Miles = "miles",
  Minutes = "minutes",
}
export const DistanceUnitValues = Object.values(DistanceUnitEnum);

export const OneMileInMeters = 1609.34;
